import type { CreateStateKeyRequest, StateKey, StateKeyResponse, StateKeyStatusResponse } from '../stateKeysApi'
import { demoApi } from './db'

export const stateKeysApi = {
	getStateKeys: async (_tenantId?: string, _impersonateAdmin?: boolean): Promise<StateKey[]> =>
		demoApi.get<StateKey[]>('/v3/state-keys'),

	createStateKey: async (
		displayName: string,
		request: CreateStateKeyRequest,
		_tenantId?: string,
	): Promise<StateKeyResponse> =>
		demoApi.post<StateKeyResponse>(`/v3/state-keys/${encodeURIComponent(displayName)}`, request),

	renameStateKey: async (oldName: string, newName: string, _tenantId?: string): Promise<StateKeyStatusResponse> =>
		demoApi.post<StateKeyStatusResponse>(
			`/v3/state-keys/${encodeURIComponent(oldName)}/rename/${encodeURIComponent(newName)}`,
		),

	deleteStateKey: async (name: string, _tenantId?: string): Promise<StateKeyStatusResponse> =>
		demoApi.delete<StateKeyStatusResponse>(`/v3/state-keys/${encodeURIComponent(name)}`),
}
